export default function ($scope, $state, changePassword, toaster) {
    $scope.passwordErrors = [];
    $scope.form = null;
    $scope.saveUser = save;

    function save() {
        if ($scope.form.$invalid) {
            return;
        }

        changePassword($scope.userData)
            .then(() => {
                $scope.passwordErrors = [];
                $state.go('account.details');
                toaster.pop('success', 'Password has been successfully changed');
            })
            .catch(data => {
                $scope.passwordErrors = data;
                toaster.pop('error', 'An error occured when changing the password');
            });
    }
}



// WEBPACK FOOTER //
// ./Client/app/account/controllers/changePassword/changePasswordCtrl.js